import React from 'react';

import {
  Box,
  Typography
} from '@mui/material';

const hours = [
  '12:00 AM',
  '1:00 AM',
  '2:00 AM',
  '3:00 AM',
  '4:00 AM',
  '5:00 AM',
  '6:00 AM',
  '7:00 AM',
  '8:00 AM',
  '9:00 AM',
  '10:00 AM',
  '11:00 AM',
  '12:00 PM',
  '1:00 PM',
  '2:00 PM',
  '3:00 PM',
  '4:00 PM',
  '5:00 PM',
  '6:00 PM'
];

const DaySchedule = () => {
  return (
    <Box
      sx={{
        height: 'calc(100vh - 250px)',
        minHeight: 590,
        overflowY: 'auto'
      }}
    >
      {hours.map(hour => (
        <Box
          key={hour}
          sx={{
            minHeight: 43,
            display: 'grid',
            gridTemplateColumns: '86px 1fr',
            borderBottom: '1px solid #EEEEEE'
          }}
        >
          <Box
            sx={{
              px: 1.5,
              display: 'flex',
              alignItems: 'flex-start',
              pt: 1,
              borderRight: '1px solid #E0E0E0'
            }}
          >
            <Typography
              sx={{
                fontSize: 12,
                color: '#424242',
                whiteSpace: 'nowrap'
              }}
            >
              {hour}
            </Typography>
          </Box>

          <Box
            sx={{
              minHeight: 43,
              '&:hover': {
                bgcolor: '#FFFDF8'
              }
            }}
          />
        </Box>
      ))}
    </Box>
  );
};

export default DaySchedule;